import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useProposalProgressPreferences } from '../../../hooks/useProposalProgressPreferences';
export function AppearanceSettings({ darkMode, onDarkModeChange }) {
    const { autoHide, setAutoHide } = useProposalProgressPreferences();
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-medium text-foreground mb-4",
                    children: "Appearance"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            className: "text-sm font-medium text-foreground",
                                            children: "Dark Mode"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm text-muted-foreground",
                                            children: "Switch between light and dark themes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: ()=>onDarkModeChange(!darkMode),
                                    className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${darkMode ? 'bg-primary' : 'bg-muted'}`,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: `inline-block h-4 w-4 transform rounded-full bg-card transition-transform ${darkMode ? 'translate-x-6' : 'translate-x-1'}`
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            className: "text-sm font-medium text-foreground",
                                            children: "Auto-hide proposal progress on complete"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm text-muted-foreground",
                                            children: "When on, the document-analysis progress bar fades out shortly after analysis completes. When off, it stays visible until you dismiss it."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>setAutoHide(!autoHide),
                                    "data-testid": Testids.proposalProgress.autoHideToggle,
                                    "aria-pressed": autoHide,
                                    className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${autoHide ? 'bg-primary' : 'bg-muted'}`,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: `inline-block h-4 w-4 transform rounded-full bg-card transition-transform ${autoHide ? 'translate-x-6' : 'translate-x-1'}`
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
